import { AbstractControl } from '@angular/forms';
import { size } from 'lodash-es';

interface Error {
  phoneLength?: boolean;
  phoneEqualNumbers?: boolean;
}

export function PhoneValidator(control: AbstractControl): Error {
  if (!control.value) return null;
  const value: string = control.value.replace(/[|&;$%@"<>()+,\-_]/g, '');
  let errors = {};

  if (value.length < 10) {
    errors = { ...errors, phoneLength: true };
  }

  if (/^(.)\1+$/.test(value)) {
    errors = { ...errors, phoneEqualNumbers: true };
  }

  return size(errors) ? errors : null;
}
